import format from '@st-operations/uikit/lib/format'

import CATEGORIES_OPTIONS_RAW from './categories-options.json'

export default function extractCategoryTree(counts, countsSuffix) {
  let result = []
  for (const raw of CATEGORIES_OPTIONS_RAW) {
    const split = raw.substring(1, raw.length).split('/')
    for (let i = 0; i < split.length; i++) {
      const fullPath = '/' + split.filter((s, index) => index >= i).join('/')
      const itemFound = findNodeByValue(result, fullPath)
      if (!itemFound) {
        const count = counts?.find((c) => c.category === fullPath)?.users || 0
        const item = {
          value: fullPath,
          label:
            split[split.length - i - 1]
              .replaceAll('_', ' ')
              .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase()) +
            ` (${format('metric', count)}${countsSuffix})`,
          count,
        }
        const previousValue = '/' + split.filter((s, index) => index !== split.length - 1).join('/')
        const parentFound = findNodeByValue(result, previousValue)
        if (parentFound) {
          if (!parentFound.children) {
            parentFound.children = []
          }
          parentFound.children.push(item)
        } else {
          result.push(item)
        }
        break
      }
    }
  }
  return result
}

function findNodeByValue(nodes, value) {
  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i]
    if (node.value === value) {
      return node
    }
    if (node.children) {
      const found = findNodeByValue(node.children, value)
      if (found) {
        return found
      }
    }
  }
  return undefined
}
